import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Connect your wallet above to mint new NFTs. ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Sit tight...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotifyError = _resolveComponent("NotifyError")!
  const _component_NotifyInfo = _resolveComponent("NotifyInfo")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isConnected)
      ? (_openBlock(), _createBlock(_component_NotifyError, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_NotifyError, {
          key: 1,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Uh oh something went wrong - " + _toDisplayString(_ctx.error) + ". See console for more details. ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_NotifyInfo, {
          key: 2,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}